import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { Text, Box, Flex } from "sprout-ui-primitives";
import { Button } from "sprout-ui-dom/dist/Button";
import Dialog from "../Dialog";
function ActionConfirmationDialog(props) {
    const { open , onRequestClose , actionText , title , content , onActionClick  } = props;
    return /*#__PURE__*/ _jsxs(Dialog, {
        open: open,
        onRequestClose: onRequestClose,
        children: [
            /*#__PURE__*/ _jsx(Box, {
                p: "24px 24px 20px 24px",
                children: /*#__PURE__*/ _jsx(Text, {
                    color: "black.87",
                    fontSize: 3,
                    fontWeight: "500",
                    children: title
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                p: "0 24px 24px 24px",
                children: /*#__PURE__*/ _jsx(Text, {
                    color: "black.60",
                    lineHeight: "24px",
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                })
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                m: "8px 4px",
                align: "center",
                justifyContent: "flex-end",
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        m: "4px",
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "outline",
                            onClick: onRequestClose,
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        m: "4px",
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "bright-blue",
                            onClick: onActionClick,
                            children: actionText
                        })
                    })
                ]
            })
        ]
    });
}
ActionConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    actionText: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onActionClick: PropTypes.func.isRequired,
    content: PropTypes.string.isRequired
};
export default ActionConfirmationDialog;
